import groupedBarChartConfig, { type GroupedBarChartConfig } from '../../chartConfigs/groupedBarChartConfig';
import Chart from 'chart.js/auto';

const initializeGroupedBarChart = (groupedBarChart: HTMLCanvasElement, chartId: string) => {
    const groupedBar = window[`groupedBarChart_${chartId}`];
    const chart = new Chart(
        groupedBarChart,
        groupedBarChartConfig({
            labels: groupedBar.labels,
            data: groupedBar.data,
            colors: {
                barColor: groupedBar.colors.bar_color,
                labelColor: groupedBar.colors.label_color,
                bar1: {
                    backgroundColor: groupedBar.colors.bar1.background_color,
                    borderColor: groupedBar.colors.bar1.border_color,
                },
                bar2: {
                    backgroundColor: groupedBar.colors.bar2.background_color,
                    borderColor: groupedBar.colors.bar2.border_color,
                },
            },
        } as GroupedBarChartConfig)
    );
};

export default initializeGroupedBarChart;
